import React, {useEffect} from "react";
import { motion } from "framer-motion";
import Breadcrumb from "../Components/Breadcrumb";
import bgImg from '../Images/about-breadcrumb.webp'
import img1 from '../Images/who-we-are-1.webp'
import img2 from '../Images/who-we-are-2.webp'
import img3 from '../Images/who-we-are-3.webp'
import img4 from '../Images/who-we-are-4.webp'
import { missionVision } from "../Data";
import WhyChoose from "../Components/WhyChoose";
import Application from "../Components/Application";
import Testimonials from "../Components/Testimonial";
import Cta from "../Components/Cta";
import Production from "../Components/Production";

const About=()=>{
      useEffect(() => {
        document.title =
          "About VigoFlex | Leading Tile Bonding Solutions in India";
    
        const metaDesc = document.querySelector("meta[name='description']");
        if (metaDesc) {
          metaDesc.setAttribute(
            "content",
            "Learn why VigoFlex is a trusted name in Gujarat for high-performance tile adhesives. Engineering strength and durability for India’s construction industry."
          );
        }
    
         const canonical = document.querySelector("link[rel='canonical']");
      if (canonical) {
        canonical.setAttribute("href", "https://vigoflex.in/about-us");
      }
    
      const ogTitle = document.querySelector("meta[property='og:title']");
      if (ogTitle) {
        ogTitle.setAttribute(
          "content",
          "About VigoFlex | Leading Tile Bonding Solutions in India"
        );
      }
    
        const ogDesc = document.querySelector("meta[property='og:description']");
      if (ogDesc) {
        ogDesc.setAttribute(
          "content",
          "Learn why VigoFlex is a trusted name in Gujarat for high-performance tile adhesives. Engineering strength and durability for India’s construction industry."
        );
      }
    
      const ogUrl = document.querySelector("meta[property='og:url']");
      if (ogUrl) {
        ogUrl.setAttribute("content", "https://vigoflex.in/about-us");
      }
    
        const ogImage = document.querySelector("meta[property='og:image']");
      if (ogImage) {
        ogImage.setAttribute(
          "content",
          "https://vigoflex.in/files/about-img.webp"
        );
      }
    
        const twitterTitle = document.querySelector("meta[name='twitter:title']");
      if (twitterTitle) {
        twitterTitle.setAttribute(
          "content",
          "About VigoFlex | Leading Tile Bonding Solutions in India"
        );
      }
    
        const twitterDesc = document.querySelector(
        "meta[name='twitter:description']"
      );
      if (twitterDesc) {
        twitterDesc.setAttribute(
          "content",
          "Learn why VigoFlex is a trusted name in Gujarat for high-performance tile adhesives. Engineering strength and durability for India’s construction industry."
        );
      }
    
        const twitterImage = document.querySelector("meta[name='twitter:image']");
      if (twitterImage) {
        twitterImage.setAttribute(
          "content",
          "https://vigoflex.in/files/about-img.webp"
        );
      }
      }, [])


const fade = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2,
    },
  },
};

const cardAnim = {
  hidden: { opacity: 0, scale: 0.98 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.4, ease: "easeOut" },
  },
};

const iconAnim = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.4 },
  },
};

    return(
        <>
        {/**BREADCRUMB */}
        <Breadcrumb
        title="About VigoFlex"
        bgImage={bgImg}
      />

      {/**WHO WE ARE SECTION */}
    <section className="who-section">
  <div className="container who-wrapper">

    {/* LEFT */}
    <motion.div
      className="who-left"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={{
        visible: {
          transition: { staggerChildren: 0.15 }
        }
      }}
    >
      <motion.h3 className="section-subheading" variants={fade}>
        Who we are ?
      </motion.h3>

      <motion.h2 className="section-heading" variants={fade}>
        Reliable Tile Adhesive Solutions
      </motion.h2>

      <motion.p className="section-text" variants={fade}>
       VigoFlex offers a complete range of high-performance tile adhesives designed to deliver strong, durable, and long-lasting bonding. From interior floors and walls to demanding exterior applications, our products are engineered to meet the needs of modern construction and evolving professional tiling standards with precision, consistency, and long-term reliability.
      </motion.p>

      <motion.p className="section-text" variants={fade}>
     Each formulation is developed using advanced polymer technology to ensure consistent performance, ease of application, and dependable results across a wide range of surfaces and site conditions. Backed by quality-focused manufacturing processes and rigorous testing standards, VigoFlex solutions empower professionals to achieve precise finishes, improved efficiency, reduced installation time, and reliable, long-term performance on every project—regardless of scale, complexity, or environmental challenges.
      </motion.p>
    </motion.div>

    {/* RIGHT */}
    <div className="who-right">

      {/* DOTS (keep but slightly calmer) */}
      <motion.div
        className="who-dots who-dots-1"
        animate={{ scale: [1, 1.3, 1], opacity: [0.5, 0.9, 0.5] }}
        transition={{ duration: 2.5, repeat: Infinity }}
      />
      <motion.div
        className="who-dots who-dots-2"
        animate={{ scale: [1, 1.3, 1], opacity: [0.5, 0.9, 0.5] }}
        transition={{ duration: 2.5, delay: 0.3, repeat: Infinity }}
      />
      <motion.div
        className="who-dots who-dots-3"
        animate={{ scale: [1, 1.3, 1], opacity: [0.5, 0.9, 0.5] }}
        transition={{ duration: 2.5, delay: 0.6, repeat: Infinity }}
      />
      <motion.div
        className="who-dots who-dots-4"
        animate={{ scale: [1, 1.3, 1], opacity: [0.5, 0.9, 0.5] }}
        transition={{ duration: 2.5, delay: 0.9, repeat: Infinity }}
      />

      {/* IMAGES (IMPORTANT: animate wrapper opacity ONLY) */}
      <motion.div
        className="who-img img1"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <motion.img
          src={img1}
          alt="Reliable Tile Adhesive Solutions 1 | VigoFlex"
          initial={{ scale: 1.05 }}
          whileInView={{ scale: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        />
      </motion.div>

      <motion.div
        className="who-img img2"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.1 }}
        viewport={{ once: true }}
      >
        <motion.img
          src={img2}
          alt="Reliable Tile Adhesive Solutions 2 | VigoFlex"
          initial={{ scale: 1.05 }}
          whileInView={{ scale: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        />
      </motion.div>

      <motion.div
        className="who-img img3"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        viewport={{ once: true }}
      >
        <motion.img
          src={img3}
          alt="Reliable Tile Adhesive Solutions 3 | VigoFlex"
          initial={{ scale: 1.05 }}
          whileInView={{ scale: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        />
      </motion.div>

      <motion.div
        className="who-img img4"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.3 }}
        viewport={{ once: true }}
      >
        <motion.img
          src={img4}
          alt="Reliable Tile Adhesive Solutions 4 | VigoFlex"
          initial={{ scale: 1.05 }}
          whileInView={{ scale: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        />
      </motion.div>

    </div>

  </div>
</section>

{/**PRODUCTION SECTION */}
<Production />

{/**MISSION VISION SECTION */}
<section className="mission-vision container">

  {/* TEXT */}
  <motion.h3
    className="section-subheading"
    variants={fade}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
  >
    Our Vision & Mission
  </motion.h3>

  <motion.h2
    className="section-heading"
    variants={fade}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
  >
    Driven by purpose. Focused on performance.
  </motion.h2>

  {/* GRID */}
  <motion.div
    className="mission-vision-grid"
    variants={container}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
  >
    {missionVision.map((item, i) => (
      <motion.div
  className="mission-vision-card"
  key={i}
  variants={cardAnim}
  whileHover={{
    scale: 1.05,
    y: -10,
    boxShadow: "0 25px 50px rgba(0,0,0,0.18)"
  }}
  transition={{ duration: 0.3, ease: "easeOut" }}
>
  <motion.div
    className="mission-vision-icon-wrapper"
    variants={iconAnim}
    whileHover={{
      scale: 1.15,
      rotate: 3
    }}
    transition={{ duration: 0.3 }}
  >
    <img src={item.icon} alt={`${item.title} | VigoFlex`} />
  </motion.div>

  <h4 className="card-heading">{item.title}</h4>
  <p className="section-text">{item.desc}</p>
</motion.div>
    ))}
  </motion.div>

</section>

{/**WHY CHOOSE US SECTION */}
        <WhyChoose />

        {/**APPLICATIONS SECTION */}
        <div className="about-pg">
        <Application />
        </div>

           {/**TESTIMONIALS SECTION */}
        <Testimonials />

        {/**CTA SECTION */}
        <Cta />
        </>
    )
}
export default About;